import { SelectGroup } from "@flixbus/honeycomb-react";
import React from "react";
import { useIntl } from "react-intl";
import { DayOfWeek } from "../../shared/types/schema";
import * as css from "./DayPicker.scss";

export type DayPickerProps = {
  value: Array<DayOfWeek>;
  disabled: Array<DayOfWeek>;
  onValueChanged: (v: Array<DayOfWeek>) => void;
  id?: string;
  isRequired?: boolean;
};

type Option = {
  id: string;
  value: DayOfWeek;
  name: DayOfWeek;
  label: string;
  checked?: boolean;
};

const DayPicker: React.FC<DayPickerProps> = ({ value, disabled = [], onValueChanged, id, isRequired = false }) => {
  const { formatMessage } = useIntl();

  const allOptions: Array<Option> = [
    {
      id: id ? `${id}-monday` : "monday",
      value: DayOfWeek.Monday,
      name: DayOfWeek.Monday,
      label: formatMessage({ id: "general.monday" }),
    },
    {
      id: id ? `${id}-tuesday` : "tuesday",
      value: DayOfWeek.Tuesday,
      name: DayOfWeek.Tuesday,
      label: formatMessage({ id: "general.tuesday" }),
    },
    {
      id: id ? `${id}-wednesday` : "wednesday",
      value: DayOfWeek.Wednesday,
      name: DayOfWeek.Wednesday,
      label: formatMessage({ id: "general.wednesday" }),
    },
    {
      id: id ? `${id}-thursday` : "thursday",
      value: DayOfWeek.Thursday,
      name: DayOfWeek.Thursday,
      label: formatMessage({ id: "general.thursday" }),
    },
    {
      id: id ? `${id}-friday` : "friday",
      value: DayOfWeek.Friday,
      name: DayOfWeek.Friday,
      label: formatMessage({ id: "general.friday" }),
    },
    {
      id: id ? `${id}-saturday` : "saturday",
      value: DayOfWeek.Saturday,
      name: DayOfWeek.Saturday,
      label: formatMessage({ id: "general.saturday" }),
    },
    {
      id: id ? `${id}-sunday` : "sunday",
      value: DayOfWeek.Sunday,
      name: DayOfWeek.Sunday,
      label: formatMessage({ id: "general.sunday" }),
    },
  ];

  const onChange = (e: { target: Option }) => {
    const newValue = [...value];

    if (e.target.checked) {
      if (!value.includes(e.target.value)) {
        newValue.push(e.target.value);
        onValueChanged(newValue);
      }
    } else {
      const index = value.indexOf(e.target.value);
      if (index !== -1) {
        newValue.splice(index, 1);
        onValueChanged(newValue);
      }
    }
  };

  const options = allOptions.map((option) => {
    return {
      ...option,
      disabled: disabled.includes(option.value),
      checked: value.includes(option.value),
      onChange,
    };
  });

  const label = isRequired
    ? `${formatMessage({ id: "bookingInfo.filter.departureDay.label" })} *`
    : formatMessage({ id: "bookingInfo.filter.departureDay.label" });

  return <SelectGroup label={label} options={options} extraClasses={css.picker} multi />;
};

export default DayPicker;
